import { render } from "./BannerTour.vue?vue&type=template&id=3e848af6&scoped=true"
import script from "./BannerTour.vue?vue&type=script&lang=js"
export * from "./BannerTour.vue?vue&type=script&lang=js"

import "./BannerTour.vue?vue&type=style&index=0&id=3e848af6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e848af6"]])

export default __exports__